import React from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';

// import widgetHelper from '../helpers/widgetHelper';
import { MSocialMediaAside } from '../components/molecules';

const mapStateToProps = state => ({
	pageId: state.head.id,
	showSocialMedia: state.head.showSocialMedia,
});

function TemplatePage({ showSocialMedia, children }) {
	// if (pageId === pageConfig.intro.id) {
	// 	widgetHelper.hideWidget();
	// } else {
	// 	widgetHelper.showWidget();
	// }

	return (
		<div>
			{children}
			{showSocialMedia && <MSocialMediaAside />}
		</div>
	);
}

export default withRouter(connect(mapStateToProps, {})(injectIntl(TemplatePage)));



// WEBPACK FOOTER //
// ./src/pages/template.page.js